import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardProcessApi } from '~/utils/api';
import { CreateProcessWebhookInput } from '../webhooksAPI/webhooksService';

export const getAll = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardProcessApi.get<RcInstanceDTO.Process[]>(`/workspaces/${workspaceId}/processes`);

export const getProcessById = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  dashboardProcessApi.get<RcInstanceDTO.Process>(
    `/workspaces/${workspaceId}/processes/${processId}`,
  );

export type EditProcessInput = Omit<Partial<RcInstanceDTO.Process>, 'id' | 'disabled_state'> & {
  id: RcInstanceDTO.Process['id'];
  disabled_state?: Pick<NonNullable<RcInstanceDTO.Process['disabled_state']>, 'reason'> | null;
};

export const editProcessById = async ({
  workspaceId,
  processId,
  process,
}: {
  workspaceId: string;
  processId: string;
  process?: EditProcessInput;
}) =>
  dashboardProcessApi.put<RcInstanceDTO.Process>(
    `/workspaces/${workspaceId}/processes/${processId}`,
    {
      ...process,
    },
  );

export const deleteOneById = async ({ workspaceId, id }: { id: string } & WithWorkspaceId) =>
  dashboardProcessApi.delete<RcInstanceDTO.Process>(`/workspaces/${workspaceId}/processes/${id}`);

export const create = async ({
  workspaceId,
  name,
  explicitOutput,
  description,
  webhookConfigs = [],
  disabledState,
}: {
  name: string;
  explicitOutput: boolean;
  description: string | null;
  webhookConfigs?: CreateProcessWebhookInput[];
  disabledState?: { reason: null | string } | null;
} & WithWorkspaceId) =>
  dashboardProcessApi.post<RcInstanceDTO.Process>(`/workspaces/${workspaceId}/processes`, {
    name,
    description,
    disabled_state: disabledState,
    config: { explicitOutput, webhookConfigs },
  });

export const generateProcessSecret = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  dashboardProcessApi.post<RcInstanceDTO.Process>(
    `/workspaces/${workspaceId}/processes/${processId}/secret`,
  );

export const deleteProcessSecret = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  dashboardProcessApi.delete<RcInstanceDTO.Process>(
    `/workspaces/${workspaceId}/processes/${processId}/secret`,
  );

export const updateProcessActivityOrder = async ({
  workspaceId,
  processId,
  order,
}: { processId: string; order: Record<number, string> } & WithWorkspaceId) =>
  dashboardProcessApi.put<RcInstanceDTO.Activity[]>(
    `/workspaces/${workspaceId}/processes/${processId}/order`,
    {
      ...order,
    },
  );
